<template>
  <div v-if="points && points.length > 0">
    <h2>{{ $t('points.yourPoints') }} {{ points }}</h2>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  beforeMount() {
    this.getPoints();
  },
  computed: {
    ...mapState({
      points: (state) => state.pointsStore.points,
    }),
  },
  methods: {
    ...mapActions({
      getPoints: 'pointsStore/getPoints',
      addPoints: 'pointsStore/addPoints',
    }),
  },
};
</script>

<style scoped lang='scss'>
  h2 {
    font-size: 20px;
    font-weight: 700;
    margin-left: 15px;
    margin-top: 40px;
  }
</style>
